import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ChangeTone = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 36 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M1.47536 19.2934H34.8047C29.2498 19.2934 26.9353 33.0172 20.4546 33.0172C13.9739 33.0172 12.1222 19.2934 1.47536 19.2934Z"
          fill="url(#paint0_linear_2591_10993)"
        />
        <path
          d="M1.47536 19.2951H34.8047C20.4546 19.2951 19.9917 30.0781 13.5109 30.0781C8.88187 30.0781 6.56734 19.2951 1.47536 19.2951Z"
          fill="url(#paint1_linear_2591_10993)"
        />
        <path
          d="M1.03996 19.2931H35.24C20.515 19.2931 17.14 12.3201 10.49 12.3201C5.73996 12.3201 4.18996 19.2931 1.03996 19.2931Z"
          fill="url(#paint2_linear_2591_10993)"
        />
        <path
          d="M1.47536 19.2942H34.8047C24.6207 19.2942 22.7691 3.6098 18.14 3.6098C13.5109 3.6098 12.5851 19.2942 1.47536 19.2942Z"
          fill="url(#paint3_linear_2591_10993)"
          fillOpacity="0.86"
        />
        <path
          d="M35.2401 19.2931H1.04004C15.7651 19.2931 19.1401 12.3201 25.7901 12.3201C30.5401 12.3201 32.0901 19.2931 35.2401 19.2931Z"
          fill="url(#paint4_linear_2591_10993)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_2591_10993"
            x1="34.8047"
            y1="26.1553"
            x2="1.47536"
            y2="26.1553"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#00E182" />
            <stop offset="1" stopColor="#005ECD" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_2591_10993"
            x1="21.6484"
            y1="24.6866"
            x2="6.73788"
            y2="24.6866"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFD706" stopOpacity="0.84" />
            <stop offset="1" stopColor="#00B212" stopOpacity="0.83" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_2591_10993"
            x1="13.64"
            y1="15.7967"
            x2="1.03996"
            y2="15.7967"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF8E09" />
            <stop offset="1" stopColor="#DE0000" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_2591_10993"
            x1="26.9109"
            y1="5.1197"
            x2="9.20335"
            y2="16.3789"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B900D7" />
            <stop offset="1" stopColor="#FFD704" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_2591_10993"
            x1="18.5901"
            y1="15.7967"
            x2="33.8901"
            y2="15.7967"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF8E09" />
            <stop offset="1" stopColor="#0016DE" />
          </linearGradient>
        </defs>
      </svg>
    )
  },
)

export default ChangeTone
